import React, { Suspense, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../authContext/useAuth';

const BlankLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuth();
  const { isAuthenticated, isInitialized } = auth;
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      // Redirect to the dashboard if authenticated
      navigate('/dashboard');
    }
  }, [isInitialized, isAuthenticated, navigate]);

  if (!isInitialized) {
    // Return loading state or a spinner while authentication state is being initialized
    return <div>Loading...</div>;
  }

  return (
    <BaseLayout>
      <Suspense fallback={<div>Loading...</div>}>
        {children}
      </Suspense>
    </BaseLayout>
  );
};

export default BlankLayout;
